import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import MerchantsDetails from './pages/merchantdetails/index.js';
import ServiceArea from './pages/service-area/index.js';
import Checkout from './pages/checkout/index.js';
import StoreSearch from './pages/store-search/index.js';
import GlobalSearch from './pages/global-search/index.js';
import Profile from './pages/profile/index.js';
import Orders from './pages/profile/Orders.js';
import TrackOrder from './pages/profile/TrackOrder.js';
import ManageAddress from './pages/profile/ManageAddress.js';
import ChangeLanguage from './pages/profile/ChangeLanguage.js';
import Category from './pages/Category/index.js';
import TermsOfUse from './pages/terms-of-use/index.js';
import AdminImpersonate from './pages/admin-impersonate/index.js';
import ReceiveInvite from './pages/admin-invite-customer/index.js';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Navigate to="/home" replace />} />
        <Route path='/home' element={<Home />} />
        <Route path="/merchant-details/:merchantConfigId" element={<MerchantsDetails />} />
        <Route path="/:merchantConfigId/search" element={<StoreSearch />} />
        <Route path='/search' element={<GlobalSearch />} />
        <Route path='/service-area' element={<ServiceArea />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/profile/orders' element={<Orders />} />
        <Route path='/profile/track-order' element={<TrackOrder />} />
        <Route path='/profile/manage-address' element={<ManageAddress />} />
        <Route path='/profile/change-language' element={<ChangeLanguage />} />
        <Route path='/category/:categoryId' element={<Category />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/admin-impersonate" element={<AdminImpersonate />} />
        <Route path="/signup-invite" element={<ReceiveInvite />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
